// import { APP_HELPER } from "../../utils"

export const META_TAGS = {
	PAGE_TITLE: process.env.REACT_APP_EN_PAGE_TITLE,
	// PAGE_TITLE: APP_HELPER.APP_BODY_DIRECTION() === "rtl" ? process.env.REACT_APP_UR_PAGE_TITLE : process.env.REACT_APP_EN_PAGE_TITLE,
	META_TITLE: process.env.REACT_APP_META_TITLE,
	META_DESCRIPTION: process.env.REACT_APP_META_DESCRIPTION,
	OPEN_GRAPH_TITLE: process.env.REACT_APP_OPEN_GRAPH_TITLE,
	OPEN_GRAPH_IMAGE: process.env.REACT_APP_OPEN_GRAPH_IMAGE,
	OPEN_GRAPH_DESCRIPTION: process.env.REACT_APP_OPEN_GRAPH_DESCRIPTION,
}
